import { createManager } from 'redux-injectors';

import reducer from './reducer';

import saga from './saga';

import { REDUCER_KEY } from './constants';

const VolunteerDetailManager = createManager({
  name: 'VolunteerDetailManager',
  key: REDUCER_KEY,
  reducer,
  saga,
});

export default VolunteerDetailManager;
